import { combineEpics, ofType } from 'redux-observable'
import { ActionsObservable, AppState, StateObservable } from '..'
import { doFetchProductByRatePlan, doFetchProducts } from './effects'
import {
  fetchProductByRatePlanFail,
  fetchProductByRatePlanSuccessful,
  fetchProductsFail,
  fetchProductsSuccessful,
} from './actions'
import { ApiError } from 'src/modules/utils/types/domain'
import { handleEffect } from 'src/modules/utils/effects'
import { TRY_FETCH_PRODUCT_BY_RATE_PLAN, TRY_FETCH_PRODUCTS } from './actionTypes'
import { switchMap, map, catchError, tap } from 'rxjs/operators'

import { from, of } from 'rxjs'
import { Action } from '../actionTypes'

const fetchProductsEpic = (
  action$: ActionsObservable,
  state$: StateObservable,
  fetchFn: any = doFetchProducts
): ActionsObservable =>
  action$.pipe(
    ofType(TRY_FETCH_PRODUCTS),
    switchMap((action: any) => {
      // As Welcome pages are not meant to be used for subscribers to manage their plans
      // but rather non subscribers to subscribe the visibilityContext is always 'signup'
      const params = {
        visibilityContext: 'store',
      }
      const effect = fetchFn(params)

      // Return the async result with loading state handled by startWith
      return from(effect).pipe(
        tap(() => handleEffect(action, effect)),
        map(fetchProductsSuccessful),
        catchError((error: ApiError) => of(fetchProductsFail(error)))
      )
    })
  )

const fetchProductByRatePlanEpic = (
  action$: ActionsObservable,
  state$: StateObservable,
  fetchFn: any = doFetchProductByRatePlan
): ActionsObservable =>
  action$.pipe(
    ofType(TRY_FETCH_PRODUCT_BY_RATE_PLAN),
    switchMap((action: any) => {
      const effect = fetchFn({ params: action.params })

      return from(effect).pipe(
        tap(() => handleEffect(action, effect)),
        map(fetchProductByRatePlanSuccessful),
        catchError((error: ApiError) => of(fetchProductByRatePlanFail(error)))
      )
    })
  )

export const productsEpic = combineEpics<Action, Action, AppState>(
  fetchProductsEpic,
  fetchProductByRatePlanEpic
)
